import * as React from "react";

import { useSizePacksProduct } from "./hooks/product";
import { format } from "lib/globalize-util";
import CircularProgress from "material-ui/CircularProgress";
import { getSizesQuery } from "./helpers";

interface IProps {
    sizePacksIds: string[];
    productId: string;
}

const SizePacks: React.FC<IProps> = ({ sizePacksIds, productId }) => {
    const [sizePacksContent, setSizePacksContent] = React.useState([]);

    const sizePacksQuery = getSizesQuery(sizePacksIds);
    const { data, isLoading } = useSizePacksProduct(sizePacksQuery, productId, { enabled: sizePacksIds.length > 0 });

    React.useEffect(() => {
        if (data) {
            setSizePacksContent(data);
        }
    }, [data]);

    if (sizePacksIds.length === 0) {
        return <div>{format("Size Packs")}</div>;
    }

    return isLoading ? (
        <CircularProgress />
    ) : (
        <div>
            {sizePacksContent.map((sizePack) => (
                <span key={sizePack._id} style={{ whiteSpace: "nowrap", margin: 5 }}>
                    [{sizePack.name} | {sizePack.pack_type}]
                </span>
            ))}
        </div>
    );
};

export default SizePacks;
